import { Text } from '@/components/text';
import { Button } from '@/components/ui/button';
import { View } from '@/components/ui/tw-wrappers';
import { Colors } from '@/constants/theme';
import React from 'react';
import { StyleSheet } from 'react-native';
import { IconSymbol, IconSymbolName } from './ui/icon-symbol';
import { PrimaryHoverCard } from './ui/primary-hover-card';

interface CtaCardProps {
  title: string;
  description?: string;
  comment?: string;
  buttonLabel: string;
  onButtonPress: () => void;
  className?: string;
  iconName?: IconSymbolName;
  iconSize?: number;
}

export function CtaCard({
  title,
  description,
  comment,
  buttonLabel,
  onButtonPress,
  className,
  iconName,
  iconSize = 20,
}: CtaCardProps) {
  return (
    // <Card backgroundColor='white' className={`md:flex-1 ${className}`} disableShadow={true} >
    <PrimaryHoverCard
      backgroundColor='#fff'
      borderColor='#E5E7EB'
      borderWidth={2}
      className={`md:flex-1 ${className}`}>
      <View className='flex-1 gap-3'>
        {iconName && (
          <View
            style={[styles.iconContainer, { width: iconSize * 2, height: iconSize * 2, borderRadius: iconSize }]}
            className='self-center'>
            <IconSymbol name={iconName} size={iconSize} color={Colors.light.primary} />
          </View>
        )}
        <Text type='subtitle' className='text-black text-center'>
          {title}
        </Text>
        {description && (
          <Text type='default' className='flex-1 text-center text-sm' style={styles.description}>
            {description}
          </Text>
        )}
        {comment && (
          <Text type='default' className='flex-1 text-center text-sm' style={styles.description}>
            {comment}
          </Text>
        )}

        <View className='mt-auto pt-4 justify-center items-center'>
          <Button label={buttonLabel} onPress={onButtonPress} outlinedUntilHover />
        </View>
      </View>
      {/* </Card> */}
    </PrimaryHoverCard>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 20,
    width: '100%',
    maxWidth: 500,
    alignSelf: 'center',
  },
  content: {
    alignItems: 'center',
    gap: 16,
    paddingVertical: 10,
  },
  iconContainer: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: 'rgba(11, 95, 255, 0.1)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textContainer: {
    alignItems: 'center',
    gap: 8,
  },
  title: {
    fontSize: 24,
    fontWeight: '700',
    color: Colors.light.text,
    textAlign: 'center',
  },
  description: {
    color: Colors.light.secondaryText,
    textAlign: 'center',
    lineHeight: 22,
  },
});
